module.exports = __webpack_public_path__ + "img/Uppsala.464983d0.jpg";